import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Icon from '../Icon/Icon.js';
import styles from './SettingsItem.module.scss.js';

function SettingsItem(_ref) {
  var icon = _ref.icon,
    header = _ref.header,
    infoText = _ref.infoText,
    dataTestId = _ref.dataTestId,
    onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("li", {
    className: classNames(styles.listItem)
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: onClick,
    id: dataTestId,
    className: styles.settingsButton
  }, /*#__PURE__*/React.createElement(Icon, {
    className: styles.icon,
    icon: icon,
    size: "large"
  }), /*#__PURE__*/React.createElement("section", {
    className: styles.infoBox
  }, /*#__PURE__*/React.createElement("h2", {
    className: styles.infoHeader
  }, header), /*#__PURE__*/React.createElement("p", {
    className: classNames('secondary', styles.infoText)
  }, infoText)), /*#__PURE__*/React.createElement(Icon, {
    icon: "icon-arrow-right",
    size: "medium",
    className: styles.arrowIcon
  })));
}
SettingsItem.propTypes = {
  icon: PropTypes.string.isRequired,
  header: PropTypes.string.isRequired,
  infoText: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  dataTestId: PropTypes.string
};
SettingsItem.defaultProps = {
  dataTestId: null
};

export { SettingsItem as default };
